'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.changeSlide = changeSlide;
exports.slideHandler = slideHandler;
exports.swipeHandle = swipeHandle;
exports.updateInfiniteSlides = updateInfiniteSlides;
exports.cleanupFade = cleanupFade;

var _updates = require('./updates');

var _animations = require('./animations');

var _util = require('./util');

var _eventHooks = require('./event-hooks');

function changeSlide(change, isIncremental) {
    var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var currentSlide = this.currentSlide;
    var previousSlide = this.currentSlide;

    if (isIncremental) {
        currentSlide += change * (this.config.options.slidesToScroll || 1);
    } else {
        currentSlide = change;
    }

    currentSlide = Math.min(Math.max(currentSlide, this.minSlidePos), this.maxSlidePos);

    if (this.currentSlide !== currentSlide || forceUpdate) {
        this.currentSlide = currentSlide;
        this.previousSlide = previousSlide;

        if (this.config.options.fade) {
            if (this.currentSlide === this.maxSlidePos) {
                this.currentSlide = 0;
            }

            if (this.currentSlide === this.minSlidePos) {
                this.currentSlide = this.maxSlidePos - 1;
            }
        }

        _updates.updateNavFor.call(this);
        _updates.updateArrowClasses.call(this);
        _updates.updateArrows.call(this);
        _updates.updateDots.call(this);
        slideHandler.call(this);

        _eventHooks.emit.call(this, this.events.slideChange, _util.getCurrentSlide.call(this));
    }
}

function slideHandler() {
    var transform = 100 * (this.currentSlide + this.slideOffset) / this.config.options.slidesToShow;
    this.elements.track.style.transform = 'translateX(-' + transform + '%)';

    if (this.config.options.fade) {
        fadeSlider.call(this);
    }
}

function swipeHandle(change) {
    if (!change) {
        return;
    }

    if (typeof change === 'string') {
        if (change === 'down' && !this.swipeIsDown) {
            this.currentSwipePosition = 0;
            this.swipeIsDown = true;
            _animations.unapplyTransition.call(this);
        } else if (change === 'up' && this.swipeIsDown) {
            this.swipeIsDown = false;
            this.swipePosition += this.currentSwipePosition;
            this.swipeDirection = this.currentSwipePosition > 0 ? -1 : 1;
            _animations.applyTransition.call(this);
        } else if (change === 'end' && !this.swipeIsDown) {
            var transform = this.slideWidth * this.currentSlide - this.swipePosition;
            var tendTowardsSwipeDirectionSlide = this.swipeDirection * this.config.options.swipeThreshold;
            var currentSlidePercentage = transform / this.slideWidth;
            var currentSlide = Math.round(currentSlidePercentage + tendTowardsSwipeDirectionSlide);

            currentSlide = Math.min(Math.max(currentSlide, this.minSlidePos), this.maxSlidePos);

            var speedPercentage = currentSlidePercentage - Math.floor(currentSlidePercentage);
            _animations.applyTransition.call(this, speedPercentage);

            changeSlide.call(this, currentSlide, false, true);
            this.swipePosition = 0;
        }
    }

    if ((typeof change === 'undefined' ? 'undefined' : _typeof(change)) === 'object' && this.swipeIsDown) {
        this.currentSwipePosition = change.left;
        var _transform = this.slideWidth * (this.currentSlide + this.slideOffset) - this.currentSwipePosition - this.swipePosition;
        if (_transform <= 0) {
            this.currentSwipePosition += _transform;
        } else if (_transform >= this.maxSwipePosition) {
            this.currentSwipePosition -= this.maxSwipePosition - _transform;
        }
        _transform = Math.min(Math.max(_transform, 0), this.maxSwipePosition);
        this.elements.track.style.transform = 'translateX(-' + _transform + 'px)';
    }
}

function updateInfiniteSlides() {
    if (this.config.options.infinite && this.currentSlide !== this.minSlidePos && this.currentSlide !== this.maxSlidePos) {
        return;
    }

    if (this.currentSlide === this.minSlidePos) {
        _animations.reduceTransition.call(this);
        this.currentSlide = this.slideCount - this.config.options.slidesToShow;
        slideHandler.call(this);
    }

    if (this.currentSlide === this.maxSlidePos) {
        _animations.reduceTransition.call(this);
        this.currentSlide = 0;
        slideHandler.call(this);
    }
}

function fadeSlider() {
    var positionDiffrence = this.currentSlide - this.previousSlide;
    var slideTransform = 100 * positionDiffrence;

    var prevSlideEl = this.elements.slides[this.previousSlide];
    var curSlideEl = this.elements.slides[this.currentSlide];

    prevSlideEl.style.transition = 'opacity ' + (this.config.options.speed || 500) + 'ms ' + (this.config.options.ease || 'linear');
    prevSlideEl.style.transform = 'translate(' + slideTransform + '%)';
    prevSlideEl.style.opacity = 0;
    prevSlideEl.style['z-index'] = 2;

    curSlideEl.style.transition = '';
    curSlideEl.style.transform = '';
    curSlideEl.style.opacity = 1;
    curSlideEl.style['z-index'] = 1;
}

function cleanupFade() {
    var currentSlide = this.currentSlide % (this.maxSlidePos - 1);
    var prevSlideEl = this.elements.slides[this.previousSlide];
    var curSlideEl = this.elements.slides[currentSlide];

    prevSlideEl.style.transition = '';
    prevSlideEl.style.transform = '';
    prevSlideEl.style.opacity = '';
    prevSlideEl.style['z-index'] = 0;

    curSlideEl.style.opacity = '';
    curSlideEl.style['z-index'] = 1;
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/slider/slide-handlers.js
// module id = ./resources/assets/js/src/slider/slide-handlers.js
// module chunks = 0